/**
 * One notification per problem. A grid firing twelve failing requests is one
 * problem to the user, not twelve.
 *
 * The Toast provider already replaces a toast that reuses an id, so this only
 * has to count the repeats within a window — the count is what turns twelve
 * silent replacements into a visible "12 times".
 *
 * This governs the TOAST only. Monitoring reporting has its own, longer window
 * in errorReporter.js; suppressing a toast must never suppress a capture, or
 * errors go invisible exactly when things are worst. Tested in
 * tests/hooks/useApiError.test.jsx.
 */
const WINDOW_MS = 6000;

const seen = new Map();

/** How many times this problem has occurred inside the current window. */
export function repeatCount(key, now = Date.now()) {
  const entry = seen.get(key);

  if (!entry || now - entry.at >= WINDOW_MS) {
    seen.set(key, { at: now, repeat: 1 });
    return 1;
  }

  entry.repeat += 1;
  return entry.repeat;
}

export function resetCoalescer() {
  seen.clear();
}
